<script>
export default {
  name: 'ItineraryAddTripThemeModal',
  props: {
    itineraryId: {
      type: Number,
      required: true,
    },
    availableTripThemes: {
      type: Array,
      default: () => [],
    },
    selectedTripThemes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      headers: [
        { text: this.$t('itinerary.tripThemeModal.table.id'), value: 'id' },
        { text: this.$t('itinerary.tripThemeModal.table.description'), value: 'description' },
      ],
      pagination: {
        rowsPerPage: 10,
        descending: false,
        sortBy: 'description',
      },
      toggled: true,
      available: [],
      selected: [],
    };
  },
  methods: {
    add(event) {
      const selected = [...this.selected];
      const available = [...this.available];
      const index = this.available.findIndex(item => item.id === event.id);
      selected.push(event);
      available.splice(index, 1);
      this.available = available;
      this.selected = selected;
    },
    remove(event) {
      const selected = [...this.selected];
      const available = [...this.available];
      const tripTheme = selected.splice(event, 1);
      available.push(tripTheme[0]);
      this.available = available;
      this.selected = selected;
    },
    update() {
      this.$emit('update', {
        itineraryId: this.itineraryId,
        contentIds: this.selected.map(tripTheme => tripTheme.id),
      });
    },
  },
  created() {
    this.available = this.availableTripThemes;
    this.selected = this.selectedTripThemes;
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('cancel');
      }
    },
  },
};
</script>

<template>
  <v-dialog
    max-width="800px"
    v-model="toggled"
  >
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>edit</v-icon>
        {{ $t('itinerary.tripThemeModal.title') }}
      </v-flex>
      <v-divider light/>
      <v-layout row wrap>
        <v-flex v-if="selected.length" sm12 pa-3>
          <v-chip
            v-for="(tripTheme, index) in selected"
            :key="`selected-trip-themes__${index}`"
            close
            color="teal"
            text-color="white"
            @input="remove(index)"
          >
            <span>
              <strong>{{ tripTheme.description }}</strong>
            </span>
          </v-chip>
        </v-flex>
        <v-flex v-else sm12 pa-3 text-xs-center class="no-trip-themes">
          <i>{{ $t('itinerary.tripThemeModal.noTripThemes') }}</i>
        </v-flex>
        <v-flex sm12>
          <v-text-field
            v-model="search"
            class="px-4"
            clearable
            clear-icon="clear"
            append-icon="search"
            :loading="loading"
            :label="$t('inputs.placeholders.search')"
          />
        </v-flex>
        <v-flex sm12>
          <v-data-table
            class="elevation-1"
            item-key="id"
            :headers="headers"
            :items="available"
            :pagination.sync="pagination"
            :loading="loading"
            :search="search"
            :no-data-text="$t('itinerary.tripThemeModal.noData')"
          >
            <template v-slot:items="props">
              <tr
                class="table-row"
                @click="add(props.item)"
              >
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.description }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn
          color="red darken-1"
          flat
          @click="toggled = false"
        >
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-btn
          :disabled="availableTripThemes === available || loading"
          :loading="loading"
          color="blue darken-1"
          flat
          @click="update"
        >
          {{ $t('inputs.actions.save') }}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<style>
  .table-row {
    cursor: pointer;
  }
  .no-trip-themes {
    color: #a6a6a6;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryAddTripThemeModal.vue